export const EXCMAGREEMENTDEVICE_SHOW_RESET = 'EXCMAGREEMENTDEVICE_SHOW_RESET'
export const EXCMAGREEMENTDEVICE_SHOW_SET_ERROR = 'EXCMAGREEMENTDEVICE_SHOW_SET_ERROR'
export const EXCMAGREEMENTDEVICE_SHOW_SET_RETRIEVED = 'EXCMAGREEMENTDEVICE_SHOW_SET_RETRIEVED'
export const EXCMAGREEMENTDEVICE_SHOW_TOGGLE_LOADING = 'EXCMAGREEMENTDEVICE_SHOW_TOGGLE_LOADING'
